import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, initialize, destroy } from 'redux-form'
import { CharField } from 'components/forms'
import { Button } from 'components/util'
import { FormattedMessage, injectIntl } from 'react-intl'
import styles from './_forgotPassword.css'
import ErrorComponent from '../ErrorComponent'
import messages from '../messages'

export const FORM_NAME = 'forgotPassword'

const validate = (values) => {
  const errors = {}
  const emailRegex = /[^\s]+@[^\s]+\.[^\s]+/
  if (!values.email) {
    errors.email = 'required'
  } else if (!values.email.match(emailRegex)) {
    errors.email = 'email/pattern'
  }
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = () => ({})

const mapDispatchToActions = {
  initialize,
  destroy,
}

export function ForgotPasswordForm (props) {
  const { sending, handleSubmit, intl } = props

  return (
    <form method='post' onSubmit={handleSubmit}>

      <CharField
        slim
        name='email'
        placeholder='Email'
        disabled={sending}
        labelComponent={null}
        normalize={(value) => value.trim()}
        errorComponent={(
          <ErrorComponent
            name={intl.formatMessage(messages.email)}
          />
        )}
      />

      <Button
        el='button'
        type='success'
        className={styles.button}
        disabled={sending}
      >
        <FormattedMessage
          id='auth.forgot_password.reset_password'
          defaultMessage='Reset Password'
        />
      </Button>
    </form>
  )
}

ForgotPasswordForm.propTypes = {
  intl: PropTypes.object,
  sending: PropTypes.bool,
  handleSubmit: PropTypes.func,
}

export const Form = reduxForm(formOptions)(ForgotPasswordForm)
export const IntlForm = injectIntl(Form)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(IntlForm)
